module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Atribuir uma bolsa a um integrante'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Bolsa",
      "items": _vm.listaBolsas,
      "item-text": "descricao",
      "item-value": "idBolsa",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.bolsista.idBolsa),
      callback: function($$v) {
        _vm.$set(_vm.bolsista, "idBolsa", $$v)
      },
      expression: "bolsista.idBolsa"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Integrante",
      "items": _vm.listaIntegrantes,
      "return-object": "",
      "item-text": "nome",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.pessoa),
      callback: function($$v) {
        _vm.pessoa = $$v
      },
      expression: "pessoa"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-month-menu', {
    attrs: {
      "label": "Mês inicial",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.bolsista.dataInicio),
      callback: function($$v) {
        _vm.$set(_vm.bolsista, "dataInicio", $$v)
      },
      expression: "bolsista.dataInicio"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-month-menu', {
    attrs: {
      "label": "Mês final",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.bolsista.dataFim),
      callback: function($$v) {
        _vm.$set(_vm.bolsista, "dataFim", $$v)
      },
      expression: "bolsista.dataFim"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.formularioValido) ? _c('div', {
    staticClass: "black--text text-justify text-h6"
  }, [_vm._v("\n\n              Eu, " + _vm._s(_vm.projeto.nomeCoordenador.toUpperCase()) + ", comprometo-me a orientar o bolsista " + _vm._s(_vm.pessoa.nome) + "  no desenvolvimento da ação de extensão\n              " + _vm._s(_vm.projeto.titulo.toUpperCase()) + " pelo período de " + _vm._s(this.dates.formatFirstDayMonth(_vm.bolsista.dataInicio)) + " a " + _vm._s(this.dates.formatLastDayMonth(_vm.bolsista.dataFim)) + ",\n              prestando as avaliações semestrais obrigatórias do bolsista e de acordo com as normas vigentes no edital.\n\n              "), _c('v-layout', {
    staticClass: "justify-center",
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": "",
      "center": ""
    },
    model: {
      value: (_vm.concordo),
      callback: function($$v) {
        _vm.concordo = $$v
      },
      expression: "concordo"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Concordo",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não concordo",
      "value": false
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido || !_vm.concordo
    },
    on: {
      "click": _vm.atribuirBolsa
    }
  }, [_vm._v("Atribuir")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34da0fe6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/bolsas/atribuir-bolsa.vue
// module id = 393
// module chunks = 0